module.exports = __webpack_public_path__ + "img/app4.6ca9c321.png";